// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"23098182","95":"f8ff93ab","174":"fc539594","738":"cffcb13e"}[chunkId] + ".chunk.js";
};